import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=5ddc7b40&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=5ddc7b40&prod&lang=scss"
import style1 from "./LayoutMain.vue?vue&type=style&index=1&id=5ddc7b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc7b40",
  null
  
)

export default component.exports